// LoginPopup.js
import { useContext, useEffect, useState } from "react";
import "./login.css";
import Popup from "../common/popup/Popup";
import { UserContext } from "../../UserContext";

import { useNavigate } from "react-router-dom";
import OtpInput from "./OtpInput";
import { callback } from "../../callback";
import MobileNumber from "./MobileNumber";
import NoOTP from "./NoOTP";
import EmailAddress from "./EmailAddress";
import { PopupContext } from "./LoginPopupContext";
import config from "../../config";

const SignupPopup = () => {
  const { hideSignupDialog, issignup } = useContext(PopupContext);
   const [domainName, setDomainName] = useState('');
   const [activeTab, setActiveTab] = useState('usingMobile');

  useEffect(() => {
    const hostname = window.location.hostname;
    setDomainName(hostname);
      document.body.classList.add('popup-open');
    return () => {
      document.body.classList.remove('popup-open');
    };
  }, []);

  const handleClose = () => {
    hideSignupDialog();
    console.log("Closing signup dialog SignupPopup.js",new Date());
  }

  const handleClick = () => {
    if (localStorage.getItem("basicDetails")) {
      let dta = JSON.parse(localStorage.getItem("basicDetails"));
      const message = "Hello, I am interested in your services.";
      const url = `https://wa.me/${
        dta?.contactNumber
      }?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    }
  };

  return (
    <>
      <div className={`popup login-popup signup-popup ${issignup ? "open" : ""}`}>
        <div className="popup-content">
          <div className="loginpopup-content">
            <div className="lp-row">
            <div className="lp-col">
              <div className="login-form-wraper" style={{ marginTop:"15px" }}>
                <div className="logo">
                  <img
                    className="myloginmodl-form-logo"
                    src={config.logoDetails.logo2}
                    decoding="async"
                    loading="lazy"
                    fetchpriority="low"
                    alt=""
                  />
                </div>

                {/* <div class="signup-tab allsport-tab">
                  <span className={`tab-btn ${activeTab ==="usingMobile"? 'active':'' }`} onClick={()=>setActiveTab("usingMobile")}><img alt="Mobile OTP" src="../images/mobile_otp.png"/> Phone Number</span>
                  <span className={`tab-btn ${activeTab ==="usingNoOTP"? 'active':'' }`} onClick={()=>setActiveTab("usingNoOTP")}><img alt="No OTP" src="../images/no_otp.png"/> Without OTP</span>
                  <span className={`tab-btn ${activeTab ==="usingEmail"? 'active':'' }`} onClick={()=>setActiveTab("usingEmail")}><img alt="Email OTP" src="../images/email_otp.png"/> Email Address</span>
                </div>
                {activeTab === "usingMobile" && issignup && <MobileNumber  />}
                {activeTab === "usingNoOTP" && issignup && <NoOTP  />}
                {activeTab === "usingEmail" && issignup && <EmailAddress />} */}
                  {window.location.hostname == "unitedwaves.live" ? "" :<div class="whatsapp-box">
                  <div className="title-text">
                    <span>Register as New User</span>
                    <h4>Get your instant ID from whatsapp</h4>
                  </div>
                  <span onClick={handleClick} target="_blank" class="create-whatsapp-link">
                    <div class="whatsapp-icon"><i class="fab fa-whatsapp"></i> </div>
                    <div class="click-here">click here</div>
                  </span>
                  </div>}
                
                {window.location.hostname == "unitedwaves.live" ? "" :
                  <div class="create-account-seperator">OR</div>}
                <MobileNumber  />
              </div>
            </div>
            </div>
            <button onClick={()=>handleClose()} className="btn login-close" style={{ background : window.location.hostname == "unitedwaves.live" ? "#979696" :"#ffffff",
                      color : window.location.hostname == "unitedwaves.live" ? "#ffffff" :"#000000" }}>
              BACK TO HOME
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignupPopup;
